

















































import { Component, Vue } from "vue-property-decorator";
import AssetsList from "./AssetsList.vue";
import { Getter } from "vuex-class";
import { ROOT_EVENTS } from "@/constants";

@Component({
  name: "assetSearch",
  components: {
    AssetsList
  }
})
class AssetSearch extends Vue {
  @Getter("wallet/mixin/getMergedAssets") mixinAssets;

  dialog = false;

  text = "";

  title = "";

  callback: any = "";

  get assets() {
    return this.mixinAssets;
  }

  mounted() {
    this.$root.$on(ROOT_EVENTS.ASSETS_SELECT, this.show);
  }

  handleClose() {
    this.text = "";
    this.dialog = false;
  }

  handleToDetail(id) {
    this.handleClose();
    if (this.callback && typeof this.callback === "function") {
      this.callback(id);
      this.callback = "";
      this.title = "";
      return;
    }
    this.$helper.toFusionPath(this, "wallet", {
      name: "snapshots-id",
      params: { id }
    });
  }

  show(callback, title) {
    this.dialog = true;
    this.callback = callback;
    this.title = title;
  }
}
export default AssetSearch;
